import axios from "axios"
import { useAppDispatch } from "../redux/hooks"
import { authenticate } from "../redux/reducers/authReducer"
import { ILoginInputs } from "../types/types"


export const useAuth = () => {
    const dispatch = useAppDispatch() 
    const login = async (authData: ILoginInputs) => {
        try{
            await axios.post('https://api.escuelajs.co/api/v1/auth/login', authData)
            .then(responce => {
                localStorage.setItem('webToken', responce.data['access_token'])
                dispatch(authenticate(responce.data['access_token']))
            })
        } catch(e) {
            console.log(e)
        }
    }

    return {login}
}